import React, { useEffect } from 'react'
import styles from './flexStyles.module.scss'
import {logo} from '../../../assets/img/dashCategoris'
import { arrowLeft, closeIcon, questionIcon, arrow, checkGreen } from '../../../assets/svg/dashboard/main'
import { useHistory, useParams } from 'react-router-dom'
import { eduIcon6 } from '../../../assets/img/dashCategoris'
import { image1, image2, image3, image4, image5, image6, image7, image8, image9 } from '../../../assets/img/dashCriterias'
import { Check } from '../../../assets/NewDashboard'
import { getVsokoDetails, getFile, getSelfExFile } from '../../../actions/dashboard'
import { useDispatch, useSelector } from 'react-redux'
import ReactLoader from 'react-loader'
import { createNotification } from '../../../components/notifications/notifications'
import ReactTooltip from 'react-tooltip'
import { DASHBOARD_ENTITIES } from '../../../utils/const'


const CARDS = [
  {name: 'Локальный нормативный акт о ВСОКО', image: image4, entity: 'has_local_act', files: 'local_act_files'},
  {name: 'Отчёт о самообследовании (по результатам опросов)', image: image9, entity: 'has_self_examination_report', files: 'self_exam_files'},
]

const Details = ({ spoMode }) => {
  
  const history = useHistory()
  const {id} = useParams()
  
  const dispatch = useDispatch()
  const {details, loading} = useSelector(state => state.dashboard)

  useEffect(() => {
    if (!parseInt(id)) return;
    dispatch(getVsokoDetails(id))
  }, [])
  

  const goTo = (link) => () => history.push(link) 

  const onDocsClick = (docs, entity) => () => {
    if (!docs?.files.length) return createNotification('error', 'Документ-подтверждение отсутствует');
    const {f_doc_hs, files} = docs
    const getFileCB = entity === 'self_exam_files' ? getSelfExFile : getFile
    getFileCB(f_doc_hs, files[0].file)
  }

  const renderCard = ({name, image, entity, files}, index) => {
    if (!Object.keys(details.vsoko)?.length) return;
    const checkMode = details.vsoko[entity] ? 'complete' : 'notComplete';
    const filesList = details.vsoko[files]
    return (
      <li key={index}>
        <img src={image} alt={name} />
        <p>{name}</p>
        <Check mode={checkMode} className={styles.checkBlock}/>
        <div onClick={onDocsClick(filesList[0], files)}>
          <span>Документ</span>
          {arrow}
        </div>
      </li>
    )
  }

  const {name, result} = details.vsoko
  const { min, max } = DASHBOARD_ENTITIES[spoMode ? 'spo' : 'high'].vsoko

  return (
    <div>
      <section className={styles.wrapper}>

        <div onClick={goTo(`/dashboard_new/accreditation${spoMode ? '?level=spo' : ''}`)}>
          <div>{arrowLeft}</div>
          <h2>{name}</h2>
        </div>
        
        <div className={styles.descriptionBlock}>
          <div>
            <div>
              <img src={eduIcon6} alt='о_О' />
              <p>Внутренняя система оценки качества образования</p>
            </div>
            <div>
              {result < max ? 'отсутствует' : 'имеется'}
              {result < max ? closeIcon : checkGreen}
            </div>
          </div>
          <div>
            <div>
              <i data-tip='custom-jsx-tooltip' data-for="custom-jsx-tooltip">{questionIcon}</i>
              <ReactTooltip id="custom-jsx-tooltip" className={styles.tooltip}>
                <p>Критериальное значение аккредитационного показателя</p>
                <ul>
                  <li>имеется = 10</li>
                  <li>отсутствует = 0</li>
                </ul>
              </ReactTooltip>
              <Check
                className={styles.checkBlock}
                mode={result >= max ? `complete` : result <= min ? `notComplete` : `middle`}
              />
            </div>
            <p>{result}</p>
            <p>баллов</p>
            <p>аккредитационного показателя</p>
          </div>
        </div>

        <ul>
          {CARDS.map(renderCard)}
        </ul>

      </section>
    </div>
  )
}

export default Details